import { Observable, BehaviorSubject, Subject } from 'rxjs';

import { HostListener, Injectable } from '@angular/core';
import { GoogleApiService, GoogleAuthService } from 'ng-gapi';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HttpHelpersService } from '../../../shared/http-helpers.service';
import { LoggerService } from '../../../shared/logger.service';
import { PICASA_GET_ALBUMS, PICASA_GET_PHOTOS } from '../../../consts/apiMethods';



const G_TOKEN = 'gtoken';
const ACCESS_TOKEN = 'access_token';
const NEXT_PAGE_ALL_IMAGES = 'nextPageAllImages';
const BASE_API = 'https://photoslibrary.googleapis.com/v1/'
const ALBUM_URL = 'https://photoslibrary.googleapis.com/v1/albums?pageSize=50';
const IMAGE_URL_SEARCH = 'https://photoslibrary.googleapis.com/v1/mediaItems:search?pageSize=50';
const IMAGE_URL = 'https://photoslibrary.googleapis.com/v1/mediaItems?pageSize=50';


const CODE_TO_TOKEN = '/ApiCenter/rest/picasa.aspx?method=code_to_token&api_origin=';
const PICASA_API = '/ApiCenter/rest/picasa.aspx';
const PICASA_TAG = 'google photos api';
@Injectable({ providedIn: 'root' })
export class PicasaServiceService {
    $gotToken: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(undefined);
    $albums: Subject<any> = new Subject<any>();
    token: any;
    code: any;
    windowRef = window as any;
    accessDenied = new Subject<boolean>();
    constructor(
        private httpHelperService: HttpHelpersService,
        private loggerService: LoggerService
    ) {
        this.token = this.getToken();
        if (this.token) {
            this.$gotToken.next(true);
        }
    }
    //@HostListener('window:storage')
    @HostListener('window:storage', ['$event'])
    //@HostListener('window:storage')
    onStorageChange(event: StorageEvent) {


        if (event.key === 'localStorage' || event.key === 'oauth_token') {
            let accessToken = window.localStorage.getItem('oauth_token');
            console.log(accessToken);
            //get albums


            const headers = new HttpHeaders()
                .set('X-Requested-With', 'XMLHttpRequest')
                .set('Content-Type', 'application/x-www-form-urlencoded;charset=UTF-8')
                .set('Authorization', 'Bearer ' + accessToken);
            this.getAllAlbums(headers, '');
            // console.log(`test --- ${event.key}`);

        }
    }

    init(callback: { (): void; (): void; }) {
        callback();

    }
    private getToken(): string {
        const token: string = sessionStorage.getItem(G_TOKEN);
        if (!token) {
            return null;
        }
        return sessionStorage.getItem(G_TOKEN);
    }
    resetToken() {
        sessionStorage.removeItem(G_TOKEN);
        sessionStorage.removeItem(ACCESS_TOKEN);
        this.token = null;
        // this.signIn(); //cant do this need user active click
        this.accessDenied.next(true);
    }
    public signIn(): void {
        this.signInTmp();
    }
    public signInTmp() {
        this.windowRef.getToken();
        this.windowRef.revokeToken();
        this.signInSuccessHandler(null);
    }

    public signOut(): any {

    }

    private signInSuccessHandler(res: { [x: string]: any; code?: string; }) {
        console.log("signInSuccessHandler");



    }

    public getAllAlbums(headers, pageToken = '', albums = undefined, lastResponse = undefined) {

        this.code = window.localStorage.getItem('client_code');
        this.httpHelperService
            .googleAjax(
                'get',
                { code: this.code },
                ' ',
                headers,
                true,
                ALBUM_URL + pageToken
                //BASE_API
            )
            .subscribe(response => {

                let param = ''
                if (albums != undefined && response.albums != undefined) {
                    response.albums.unshift(...albums);
                }
                if (response.nextPageToken) {
                    param = "&pageToken=" + response.nextPageToken;
                    return this.getAllAlbums(headers, param, response.albums, response);
                }
                if (response.albums == undefined) {
                    if (lastResponse == undefined) {
                        response.albums = [];
                    }
                    else {
                        response = lastResponse;
                    }
                }
                response.albums = response.albums.reverse();
                // this.getAllImagesAlbum(headers,'',undefined,response);
                response = this.addAllImagesAlbum(response);
                this.token = response;
                this.$gotToken.next(true);
                this.$albums.next(response);
            });
    }
    private addAllImagesAlbum(res) {
        // if( !(res?.albums?.some(image => image.id == "allImages"))){ // if allImages album doesnt exist
        let album = { id: 'allImages', 'title': 'כל התמונות', 'productUrl': '', 'mediaItemsCount': '', 'coverPhotoBaseUrl': '/../../assets/icons/icon_pic.svg?', 'coverPhotoMediaItemId': '' };
        res.albums.push(album);
        // }
        return res;
    }
    private getAllImagesAlbum(headers, pageToken = '', images = undefined, res = undefined) {
        // if( !(res?.albums?.some(image => image.id == "allImages"))){ // if allImages album doesnt exist
        //     let album = {id:'allImages','title': 'כל התמונות','productUrl' : '','mediaItemsCount':'','coverPhotoBaseUrl':'','coverPhotoMediaItemId':''};
        //     res.albums.push(album);
        // }
        return this.httpHelperService
            .googleAjax(
                'get',
                { code: this.code },
                ' ',
                headers,
                true,
                IMAGE_URL + pageToken
                //BASE_API
            )
        //.subscribe( response => {
        //console.log('liran')
        // let sol = await  this.getAllData(response,images,headers);
        // return sol;
        // });
        // return res.mediaItems;;
    }
    private getAllData(response, images, headers) {
        let param = ''
        if (images != undefined) {
            response.mediaItems.push(...images);
        }
        // res.albums.map(album =>{
        //     if(album.id === "allImages"){
        //         album.push(response.mediaItems);
        //     }
        // });
        // if(res){
        //     res = response;
        // res.mediaItems.push(...response.mediaItems);
        if (response.mediaItems.length > 100) return response;
        //}

        if (response.nextPageToken) {
            debugger
            param = "&pageToken=" + response.nextPageToken;
            return this.getAllImagesAlbum(headers, param, response.mediaItems, undefined);
        }

        this.token = response;
        return response;
    }
    getAlbums(): Observable<any> {
        if (!this.token) {
            return;
        }
        return this.httpHelperService.ajax(
            'get',
            { method: PICASA_GET_ALBUMS, token: this.token },

            null,
            false,
            ALBUM_URL
            //BASE_API
        );
    }

    getPhotos(id: string, index?: number): Observable<any> {
        let accessToken = window.localStorage.getItem('oauth_token');
        const nextPageAllImages = sessionStorage.getItem(NEXT_PAGE_ALL_IMAGES) ? "&pageToken=" + sessionStorage.getItem(NEXT_PAGE_ALL_IMAGES) : '';
        //let payload = {albumId:id,pageSize:'50'};
        const headers = new HttpHeaders()
            .set('X-Requested-With', 'XMLHttpRequest')
            .set('Content-Type', 'application/x-www-form-urlencoded;charset=UTF-8')
            .set('Authorization', 'Bearer ' + accessToken);
        // .set('albumId','Bearer ' + JSON.stringify(payload));
        if (id == "allImages") {
            return this.getAllImagesAlbum(headers, nextPageAllImages, undefined, undefined);
        }
        if (!this.token || !id) {
            return;
        }
        return this.httpHelperService.googleAjax(
            'POST',
            { albumId: id },
            ' ',
            headers,
            true,
            IMAGE_URL_SEARCH + nextPageAllImages
            //BASE_API
        );
    }
}
